<template lang="pug">
  div.heatmap-settings
    e-toolbar(
      :items="items"
      @deleteItems="deleteItems"
      :hideRemoveButton="true"
      :showTotal="true"
      :hideImportBtn="true"
      :showViewPanel="false"
    )
    e-table(
      :items="items"
      @deleteItem="deleteItem"
      @editItem="editItem"
      :showCheckbox="false"
    )
      div(slot="color" slot-scope="{row}")
        div(class='color' :style="{'background-color':row.color}")

    router-view
</template>
<style>
  .heatmap-settings .color {
    width: 23px;
    height: 23px;
  }

  .heatmap-settings .color::after {
    content: '';
    width: 100%;
    height: 100%;
  }
</style>
<script>
    import {map} from '../../api/api-endpoints.js'
    import tableMixin from "../../components/table/table-mixin.js"

    const HEATMAP_TYPE = 'population'

    export default {
        mixins: [tableMixin],
        methods: {
            getEndpoint(route, fromRoute) {
                return map.heatMapSettings(route, HEATMAP_TYPE)
            },
            getDeleteUrl(id) {
                return map.heatMapSettingsItem(id)
            }
        }
    };
</script>
